import Layout from '@/layout'

const villageRouter = {
  path: '/',
  component: Layout,
  children: [
    {
      path: '/periphery',
      name: 'periphery',
      meta: {
        title: '周边商城',
      },
      component: () => import('@/views/periphery/index.vue'),
    },
    {
      path: '/periphery/goodsDetail/:id/:integral',
      name: 'goodsDetail',
      meta: {
        title: '详情',
      },
      component: () => import('@/views/periphery/goodsDetail.vue'),
    },
    {
      path: '/periphery/store/:storeId',
      name: 'store',
      meta: {
        title: '店铺详情',
      },
      component: () => import('@/views/periphery/store.vue'),
    },
    {
      path: '/periphery/settlement/:storeId/:storeName/:saleNum/:goodsId/:integral',
      name: 'settlement',
      meta: {
        title: '确认订单',
      },
      component: () => import('@/views/periphery/settlement.vue'),
    },
    {
      path: '/periphery/orderList/:id',
      name: 'orderList',
      meta: {
        title: '订单列表',
      },
      component: () => import('@/views/periphery/orderList.vue'),
    },
    {
      path: '/periphery/evaluate/:orderId/:goodsId',
      name: 'evaluate',
      meta: {
        title: '评价',
      },
      component: () => import('@/views/periphery/evaluate.vue'),
    },
    {
      path: '/periphery/evaluateList/:id',
      name: 'evaluateList',
      meta: {
        title: '评价列表',
      },
      component: () => import('@/views/periphery/evaluateList.vue'),
    },
  ],
}

export default villageRouter
